import { render, staticRenderFns } from "./calendarbirthdayControl.vue?vue&type=template&id=6a98ef83&"
import script from "./calendarbirthdayControl.js?vue&type=script&lang=js&"
export * from "./calendarbirthdayControl.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\Bont\\Frontend\\BontScheduler.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a98ef83')) {
      api.createRecord('6a98ef83', component.options)
    } else {
      api.reload('6a98ef83', component.options)
    }
    module.hot.accept("./calendarbirthdayControl.vue?vue&type=template&id=6a98ef83&", function () {
      api.rerender('6a98ef83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/common/calendar/calendarbirthdayControl.vue"
export default component.exports